import { Injectable } from '@angular/core';

@Injectable()
export class AssetExportHelperService {
  public paginateAssets(flattenAssets: any[], itemsPerPage: number): any[][] {
    if (!flattenAssets?.length) {
      return [];
    }
    const totalPages: number = Math.ceil(flattenAssets.length / itemsPerPage);
    const pages: any[][] = [];
    for (let i = 0; i < totalPages; i++) {
      const start = i * itemsPerPage;
      const end = (i + 1) * itemsPerPage;
      pages.push(flattenAssets.slice(start, end));
    }
    return pages;
  }

  public calculateTotalPages(flattenAssetsLength: number, itemsPerPage: number): number {
    return Math.ceil(flattenAssetsLength / itemsPerPage);
  }

  public processAffectedAssets(
    res: { assetListId: string; deliveryDate?: string }[],
    dateHelperService: { fromDateToDatepicker: (date: Date) => any }
  ): Record<string, { deliveryDate?: any }> {
    const affectedAssets: Record<string, { deliveryDate?: any }> = {};
    for (const item of res) {
      affectedAssets[item.assetListId] = { ...item };
      if (item.deliveryDate) {
        affectedAssets[item.assetListId].deliveryDate = dateHelperService.fromDateToDatepicker(
          new Date(item.deliveryDate)
        );
      }
    }
    return affectedAssets;
  }
}
